import { ShowroomShortlistItem } from "../models/showroom-shortlist-item";

export interface ShowroomShortlistItemResponse {
  variantSkuId: number;
  skuName: string;
  category: string;
  subCategory: string;
  imageUrl: string;
  thumbnailImageUrl: string;
}

export interface GetShowroomShortlistResponse {
  items: ShowroomShortlistItemResponse[];
  success: boolean;
  errors: string[];
}

export class ShowroomShortlistResponses {
  public static getShowroomShortlist(response: GetShowroomShortlistResponse): ShowroomShortlistItem[] {
    if (!response) {
      return null;
    }

    return response.items.map(item => ShowroomShortlistResponses.getShowroomShortlistItem(item));
  }

  public static getShowroomShortlistItem(response: ShowroomShortlistItemResponse): ShowroomShortlistItem {
    if (!response) {
      return null;
    }

    const showroomShortlistItem = new ShowroomShortlistItem();

    showroomShortlistItem.imageUrl = response.imageUrl;
    showroomShortlistItem.skuName = response.skuName;
    showroomShortlistItem.category = response.category;
    showroomShortlistItem.subCategory = response.subCategory;
    showroomShortlistItem.thumbnailImageUrl = response.thumbnailImageUrl;
    showroomShortlistItem.variantSkuId = response.variantSkuId;

    return showroomShortlistItem;
  }
}
